const m = "manager";

export default {
  enums: "common/enums",
  branches: `${m}/branches`,
  complementsGroups: `${m}/complements-groups`,
  products: `${m}/products`,
  productsCategories: `${m}/product-categories`,
  periods: `${m}/periods`,
  companies: `${m}/companies`,
  upload: "common/upload",
  orders: `${m}/orders`,
  users: `${m}/users`,
  customers: `${m}/customers`,
  statuses: `${m}/statuses`,
  loyalty: `${m}/loyalty`,
};
